<template>
    <div :class="containerClass">
        <label :for="id" class="block font-bold">{{ label }}</label>
        <div v-if="subtitle" class="text-sm text-gray-700">
            {{ subtitle }}
        </div>
        <div class="mt-1">
            <div
                class="
                    space-y-4
                    sm:flex sm:items-center sm:space-y-0 sm:space-x-10
                "
            >
                <div
                    v-for="radio in radioList"
                    :key="radio.key"
                    class="flex items-center"
                >
                    <input
                        :id="radio.key"
                        :name="id"
                        :value="radio.key"
                        :checked="radio.key == modelValue"
                        @input="$emit('update:modelValue', $event.target.value)"
                        type="radio"
                        class="
                            focus:ring-indigo-500
                            h-4
                            w-4
                            text-indigo-600
                            border-gray-300
                        "
                    />
                    <label
                        :for="radio.key"
                        class="ml-3 block text-sm font-medium text-gray-700"
                    >
                        {{ radio.name }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "modelValue",
        "id",
        "label",
        "subtitle",
        "containerClass",
        "radioList",
    ],
    emits: ["update:modelValue"],
};
</script>
